import { render, staticRenderFns } from "./BottomWidget.vue?vue&type=template&id=edc428d6&scoped=true"
import script from "./BottomWidget.vue?vue&type=script&lang=js"
export * from "./BottomWidget.vue?vue&type=script&lang=js"
import style0 from "./BottomWidget.vue?vue&type=style&index=0&id=edc428d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc428d6",
  null
  
)

export default component.exports